import * as React from 'react';

function SvgCfpLogoAbbreviated(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 96 40"
      {...props}>
      <path
        fill="#434343"
        d="M95.328 15.987a6.67 6.67 0 0 1-.782 3.17q-.754 1.48-2.404 2.383-1.624.903-4.115.903H84.64v8.083h-4.053V9.474h7.448q2.344 0 3.997.845 1.65.846 2.46 2.325c.56.986.843 2.1.843 3.35zm-7.473 3.049c1.12 0 1.95-.263 2.491-.781q.812-.819.812-2.261c0-2.05-1.101-3.081-3.303-3.081H84.64v6.123zM77.425 9.474v3.406h-8.537v5.398h6.538v3.348h-6.538v8.9h-4.104V9.474zM40.557 20.01q-.002-3.036 1.387-5.431 1.417-2.423 3.823-3.746c1.624-.902 3.446-1.36 5.453-1.36q3.52 0 6.176 1.773 2.648 1.768 3.702 4.899h-4.846q-.721-1.477-2.046-2.211-1.295-.741-3.011-.74-1.84.002-3.28.858-1.418.829-2.231 2.362c-.524 1.02-.78 2.224-.78 3.602s.262 2.555.78 3.601q.813 1.53 2.231 2.393 1.449.827 3.28.827 1.716.002 3.011-.74 1.325-.768 2.046-2.242h4.846q-1.055 3.156-3.702 4.93-2.618 1.74-6.175 1.741-3.01-.002-5.454-1.328a10.15 10.15 0 0 1-3.823-3.745c-.92-1.591-1.387-3.402-1.387-5.431z"
      />
      <path
        fill="#007BFF"
        d="M32.65.541a.528.528 0 0 0-.922-.363L27.187 5.27a12.76 12.76 0 0 0-7.523-2.452c-5.707 0-10.554 3.761-12.29 8.982a12.7 12.7 0 0 1 5.831-1.413c7.172 0 12.986 5.93 12.986 13.244 0 1.494-.243 2.924-.69 4.263 4.242-2.18 7.155-6.657 7.155-11.831V.54z"
      />
      <path
        fill="#CC5EAE"
        d="M6.466 16.295c0-1.468.243-2.874.69-4.19A13.02 13.02 0 0 0 0 23.712v15.23a.53.53 0 0 0 .922.357l4.515-4.973a12.92 12.92 0 0 0 7.552 2.433c5.708 0 10.556-3.697 12.293-8.829a12.9 12.9 0 0 1-5.833 1.39C12.276 29.32 6.46 23.49 6.46 16.3z"
      />
    </svg>
  );
}
export default SvgCfpLogoAbbreviated;
